import { IOptions } from "../types";

export const OPTIONS_KEY = "__options__";
export const DEFAULT_OPTIONS: IOptions = {
  channel: "agora_az95sv",
  userName: "gautham",
  userId: 0,
  appId: "566b92901ff14d13b443c8e7a3efa4d7",
  token: "",
};

export enum EMobileActiveTab {
  AGENT = "agent",
  CHAT = "chat",
}

export const MOBILE_ACTIVE_TAB_MAP = {
  [EMobileActiveTab.AGENT]: "Agent",
  [EMobileActiveTab.CHAT]: "Chat",
};

export enum VideoSourceType {
  CAMERA = 'camera',
  SCREEN = 'screen',
}
